export default "__VITE_ASSET__Ih3GxUpB__"